import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL, ACCESS_TOKEN_NAME, Image_Base_Url, ACCESS_Role_ID, ACCESS_Log_In_User_Id } from '../constants/apiConstants';
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import bannerIcon1 from "../assets/img/logo/banner-icon1.png";


// Import images

const TopperSlider = () => {
const [topperInfo, setTopperInfo] = useState([]);
const [loading, setLoading] = useState(true);  // Handle loading state
const user_id = ACCESS_Log_In_User_Id();
const role_id = ACCESS_Role_ID();
const { id } = useParams();
    const [ids, setIds] = useState(id);


  const fetchTopper = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/getToppers?user_id=${ids}`);
      console.log("Topp", response.data);
      console.log(Image_Base_Url);
      setTopperInfo(response.data);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTopper();
  }, []); 
  return (
    <div className="institute-slider-container topper-slider">
      {/* Show loader if data is still being fetched */}
      {loading ? (
        <p>Loading institutes...</p>
      ) : topperInfo.length > 0 ? (
        <OwlCarousel
          className="owl-theme"
          loop
          margin={15}
          nav
          autoplay
          autoplayTimeout={3000}
          responsive={{
            0: { items: 1 },
            600: { items: 1 },
            1000: { items: 2 },
          }}
        >
          {topperInfo.map((topper, index) => (
            
            <div className="item event-item" key={topper.id}>
              <div class="item event-item text-center topr_ctr" key={topper.id}>
                <p class="topper_title">AIR {topper.rank}</p>
                <p class="name_title">{topper.name}</p>
                <p class="course_title">{topper.exam}</p>
            </div>
            <div class="text-center">
                <img src={`${Image_Base_Url}${topper.image}`} alt="thumb" />
            </div>
            </div>
          ))}
        </OwlCarousel>
      ) : (
        <p>No toppers available.</p>
      )}
    </div>
  );
};

export default TopperSlider;


